import { LocalizedData } from 'src/app/core/domain/localization.model';
import { LocalizedDataEntity } from './dynamic-incentive-program/entities/dynamic-incentive-program-entity';

export function mapToLocalizedData(param: LocalizedDataEntity): LocalizedData {
  return {
    ar: param.ar || '',
    en: param.en || '',
  };
}
